import { ThunkDispatch } from 'redux-thunk';
import { setQueryFromSearchParameters } from '../Util/QueryFromParameters.ts';
import { UpdateFitAssistantPriceAndATC } from '../../FitAssistantShared/Functions.js';
import { addSolutionComponents } from '../Slices/MatchingProductsSlice.ts';
import { CarInformation, InitialData, StepData } from '../Types/FitAssistantData.ts';
import { SolutionComponent } from '../Types/MatchingProducts.ts';
import { ProductDetail } from '../Types/ProductDetail.ts';
import { UnknownAction } from 'redux';
import { UpdateFitAssistantPriceAndATCForPDPExtranet } from '../Util/ProductPageUtils.tsx';

export class ProductPageHelper {
  public static HandleProductPageData(
    currentStepData: StepData | undefined,
    productDetail: ProductDetail,
    initialData: InitialData,
    carInformation: CarInformation[],
    dispatch: ThunkDispatch<unknown, unknown, UnknownAction>
  ): void {
    let selectedRack = currentStepData?.data.find((x) => x.Selected === true);

    if (!selectedRack) return;

    let productIds = selectedRack?.SolutionProducts?.map((x) => x.ProductId);
    let currentProductId = productDetail.ProductId;
    let currentErpOutdoor = productDetail.ErpOutdoor;
    let name = productDetail.ProductName;
    let webtitle2 = productDetail.WebTitle2;
    let rrp = productDetail.RRP;
    let currentSolutionComponent = {
      ProductId: currentProductId,
      Name: name,
      Webtitle2: webtitle2,
      ErpOutdoor: currentErpOutdoor,
      RRP: rrp,
    };
    let adapterId = initialData?.RackMountingAdapter?.ProductId;
    let adapterName = initialData?.RackMountingAdapter?.Name;
    let adapterErpOutdoor = initialData?.RackMountingAdapter?.ErpOutdoor;
    let adapterWebtitle2 = initialData?.RackMountingAdapter?.Webtitle2;
    let adapterRRP = initialData?.RackMountingAdapter?.RRP;
    let adapterComponent = {
      ProductId: adapterId,
      Name: adapterName,
      Webtitle2: adapterWebtitle2,
      ErpOutdoor: adapterErpOutdoor,
      RRP: adapterRRP,
    };
    let productIdsForATC = adapterId ? [...productIds, currentProductId, adapterId] : [...productIds, currentProductId];

    let componentList = adapterId
      ? ([currentSolutionComponent, ...selectedRack.SolutionProducts, adapterComponent] as SolutionComponent[])
      : ([currentSolutionComponent, ...selectedRack.SolutionProducts] as SolutionComponent[]);

    dispatch(addSolutionComponents(componentList));

    if (window._THULEDATA?.isExtranet) {
      UpdateFitAssistantPriceAndATCForPDPExtranet(componentList);
    } else {
      UpdateFitAssistantPriceAndATC(productIdsForATC);
    }

    setQueryFromSearchParameters(initialData.FitAssistantCookieName, carInformation);
  }

  public static HandleRackMountingProductPageData(
    productDetail: ProductDetail,
    initialData: InitialData,
    dispatch: ThunkDispatch<unknown, unknown, UnknownAction>
  ) {
    let currentProductId = productDetail.ProductId;
    let currentErpOutdoor = productDetail.ErpOutdoor;
    let name = productDetail.ProductName;
    let webtitle2 = productDetail.WebTitle2;
    let rrp = productDetail.RRP;
    let currentSolutionComponent = {
      ProductId: currentProductId,
      Name: name,
      Webtitle2: webtitle2,
      ErpOutdoor: currentErpOutdoor,
      RRP: rrp,
    };
    let adapterId = initialData?.RackMountingAdapter?.ProductId;
    let adapterName = initialData?.RackMountingAdapter?.Name;
    let adapterErpOutdoor = initialData?.RackMountingAdapter?.ErpOutdoor;
    let adapterWebtitle2 = initialData?.RackMountingAdapter?.Webtitle2;
    let adapterRRP = initialData?.RackMountingAdapter?.RRP;
    let adapterComponent = {
      ProductId: adapterId,
      Name: adapterName,
      Webtitle2: adapterWebtitle2,
      ErpOutdoor: adapterErpOutdoor,
      RRP: adapterRRP,
    };

    let productIdsForATC = adapterId ? [currentProductId, adapterId] : [currentProductId];

    let componentList = adapterId
      ? ([currentSolutionComponent, adapterComponent] as SolutionComponent[])
      : ([currentSolutionComponent] as SolutionComponent[]);

    dispatch(addSolutionComponents(componentList));

    if (window._THULEDATA?.isExtranet) {
      UpdateFitAssistantPriceAndATCForPDPExtranet(componentList);
    } else {
      UpdateFitAssistantPriceAndATC(productIdsForATC);
    }

    if (adapterId) dispatch(addSolutionComponents([currentSolutionComponent, adapterComponent] as SolutionComponent[]));
  }
}
